export enum TagModeEnum {
  default = "",
  News = "Tin tức",
  Image = "Image",
  Video = "Video",
}

export enum ZoneStatusEnum {
  Active = 1,
  NotActive,
}

export function getZoneStatusTitle(status: number) {
  switch (status) {
    case ZoneStatusEnum.Active:
      return "Hoạt động";
    case ZoneStatusEnum.NotActive:
      return "Không hoạt động";
    default:
      return "";
  }
}

//Loại chuyên mục
export enum ZoneTypeEnum {
  Default = 0,
  Course = 1,
  Blog,
  Guide,
}
export function getZoneTypeTitle(type: number) {
  switch (type) {
    case ZoneTypeEnum.Course:
      return "Khóa học";
    case ZoneTypeEnum.Blog:
      return "Tin tức";
    case ZoneTypeEnum.Guide:
      return "Hướng dẫn";
    default:
      return "-- Chọn loại --";
  }
}

export enum TagTypeEnum {
  Tag = 0,
  Thread = 1,
  Topic = 2,
}

export function getTagTypeTitle(type: number) {
  switch (type) {
    case TagTypeEnum.Tag:
      return "tag";
    case TagTypeEnum.Thread:
      return "dòng sự kiện";
    default:
      return "chủ đề";
  }
}

export enum BannerStatusEnum {
  Actived = 1,
  NotActived = 2,
}

export function getBannerStatusTitle(type: number) {
  switch (type) {
    case BannerStatusEnum.Actived:
      return "Hiển thị";
    case BannerStatusEnum.NotActived:
      return "Không hiển thị";
    default:
      return "";
  }
}

export enum BannerTypeEnum {
  Image = 1,
  Flash = 2,
  Embed = 3,
}

export function getBannerTypeTitle(type: number) {
  switch (type) {
    case BannerTypeEnum.Image:
      return "Banner ảnh";
    case BannerTypeEnum.Flash:
      return "Banner flash";
    case BannerTypeEnum.Embed:
      return "Mã nhúng";
    default:
      return "";
  }
}

export enum ObjectTypeEnum {
  SystemFunction = 0,
  News = 1,
  Tag,
  Topic, //Chủ đề
  Thread, //Dòng sự kiện
}

export function getObjectTypeTitle(type: number) {
  switch (type) {
    case ObjectTypeEnum.SystemFunction:
      return "Chức năng hệ thống";
    case ObjectTypeEnum.News:
      return "Tin tức";
    case ObjectTypeEnum.Tag:
      return "Tag";
    case ObjectTypeEnum.Thread:
      return "Dòng sự kiện";
    case ObjectTypeEnum.Topic:
      return "Chủ đề";
    default:
      return "";
  }
}

export enum IdentityErrorsEnum {
  InvalidUserName = "Tên đăng nhập không hợp lệ",
  DuplicateUserName = "Tên đăng nhập đã tồn tại",
  InvalidEmail = "Email không hợp lệ",
  Video = "Video",
}

export const CategoryType = {
  /// <summary>
  /// Hình thức điều trị (Loại điều trị)
  /// </summary>
  treatmentType: "treatment-type",

  /// <summary>
  /// Nhóm lý do (nhóm bệnh)
  /// </summary>
  diseaseType: "disease-type",

  /// <summary>
  /// Lý do từ chối hồ sơ
  /// </summary>
  resonReject: "reson-reject",

  /// <summary>
  /// Lấy tên loại
  /// </summary>
  /// <param name="type">Loại</param>
  /// <returns>Tên loại</returns>
  getCategoryTypeTitle(type: string) {
    switch (type) {
      case this.treatmentType:
        return "Hình thức điều trị";
      case this.diseaseType:
        return "Nhóm lý do";
      case this.resonReject:
        return "Lý do từ chối hồ sơ";
      default:
        return "";
    }
  },
};
